// Weather conditions List
export const weatherConditions = [
    "Sunny/Clear",
    "Overcast",
    "Cloudy",
    "Partly Cloudy",
    "Thunderstorms",
    "Rainy",
    "Intermittent Rain",
    "Windy",
    "Severe Weather",
    "Snow",
    "Fog"
]